import { useTranslation } from 'react-i18next';interface ShareCostLogoProps {
  className?: string;
}

export function ShareCostLogo({ className = 'h-7 w-7' }: ShareCostLogoProps) {
  const { t } = useTranslation();
  return (
    <img
      src="/icon.png"
      alt={t('auth:title')}
      className={className}
    />
  );
}
